import {useState} from 'react'
import {GoLocation} from 'react-icons/go';
import {BsClock} from 'react-icons/bs';
import { useNavigate } from 'react-router-dom';

const Contact = () => {
  
  const [show1,setshow1]=useState(true)
  const [user,setuser]=useState({
    name:'',
    email:'',
    message:''
  })
  const navigate=useNavigate()
  function getdata(e){
const name=e.target.name;
 const value=e.target.value;
 setuser({...user,[name]:value})

  }

const set=async(e)=>{
  e.preventDefault()
const {name,email,message}=user
  const res=await fetch('https://my-kart-auth-default-rtdb.firebaseio.com/contact-form-data.json',
  { method:'POST',
  headers:{
    'Content-Type':"application/json",
},
body:JSON.stringify({
 name,
 email,
 message
})
})
  setshow1(false)
  setTimeout(()=>{
    navigate('/')
  },3000)

}
  return (
    <>
    <h1 className={`pt-4 font-semibold text-lg md:text-2xl text-blue-500   text-center ${show1 &&'hidden'} `}>Thanks for contact with us !!</h1>
    <div className='flex justify-center my-8 md:flex-row flex-col md:space-x-6 items-center space-y-8 md:space-y-0'>
      
      <form onSubmit={set} method='POST' className=' inline-block bg-slate-50 p-2 md:p-4 rounded-xl md:h-[328px] '>
        <div className='mb-5'>
           <h1 className='md:text-3xl text-2xl font-bold sm:mx-2  '>contact us</h1>
           <p className='sm:mx-2 mb-5'>Fill out the form for contact with our team </p>
           </div>
           <label className='block mt-2 md:mt-[33px]'>
           <span className='sm:text-lg text-base font-semibold'>Your Name : </span>
           <input type='text' name='name' value={user.name} onChange={getdata} required className='px-2 py-[2px] border-2 sm:w-[260px] w-[180px] rounded-lg sm:ml-[23px] ml-[17px]'/>
           </label>

           <label className='block mt-2 '>
           <span className='sm:text-lg text-base font-semibold'>Your Email : </span>
           <input type='email' name='email' value={user.email} onChange={getdata} required className='px-2 py-[2px] border-2 sm:w-[260px] w-[180px] rounded-lg sm:ml-[26px] ml-[20px]'/>
           </label>

           <label className='flex items-center mt-2'>
           <span className='sm:text-lg text-base font-semibold'>Your Message :  </span>
           <textarea type='text' name='message' value={user.message} onChange={getdata} required className='px-2 py-[2px] border-2 sm:w-[260px] w-[180px] rounded-lg sm:ml-[4px] ml-[3px] ' rows='2' />
              </label>
             
           <button className='m-2  md:mt-[10px] px-2 py-1 bg-nav rounded-lg active:scale-105 hover:text-black' 
          >submit</button>
      </form>
      <div className='flex md:flex-col flex-col sm:flex-row space-x-0 sm:space-x-5 md:space-x-0 sm:space-y-0  md:space-y-6 space-y-6'>
        <div className='px-5 py-7 bg-slate-50 rounded-xl w-[310px]  text-lg'>
           <h1 className='text-xl font-semibold mb-3'> <GoLocation className='inline-block'/>    Address</h1>
           <p>2/373 B Nawabganj Kanpur </p>
           <p>Uttar Pradesh, India</p>
        </div>

        <div className='px-5 py-7 bg-slate-50 rounded-xl w-[310px] text-lg'>
           <h1 className='text-xl font-semibold mb-3'> <BsClock className='inline-block'/>    Open Hours</h1>
           <p>Everyday </p>
           <p>24 Hours</p>
        </div>

      </div>
    </div>
    </>
  )
}

export default Contact


